import { render, staticRenderFns } from "./drop.vue?vue&type=template&id=21760210"
import script from "./drop.vue?vue&type=script&lang=js"
export * from "./drop.vue?vue&type=script&lang=js"
import style0 from "./drop.vue?vue&type=style&index=0&id=21760210&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21760210')) {
      api.createRecord('21760210', component.options)
    } else {
      api.reload('21760210', component.options)
    }
    module.hot.accept("./drop.vue?vue&type=template&id=21760210", function () {
      api.rerender('21760210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploader/drop.vue"
export default component.exports